<template>
  <OnboardingLayout
    title="Pay Deposit"
    imageDescription="Make payment to get started"
    description="Join the thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="handleContinue"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div>
      <i
        style="
          font-size: 14px;
          font-weight: bold;
          color: red;
          margin-bottom: 20px;
        "
        >NB: Card used for payment would be set as default for recurring
        payments!</i
      >
      <form>
        <div class="kyc-row">
          <div class="first">First Name: {{ summary.firstname }}</div>
          <div class="first">Last Name: {{ summary.lastname }}</div>
          <div class="first">Email Address: {{ summary.email }}</div>
          <div class="first">Package type: {{ summary.packagetype }}</div>
          <div class="first">Product type: {{ summary.producttype }}</div>
          <div class="first">
            Number of Inverter: {{ summary.numInverters }}
          </div>
        </div>

        <p style="margin-bottom: 20px">
          Paying Now
          <span class="amount">
            NGN{{ Intl.NumberFormat("en-US").format(+summary.amount || 0) }}
          </span>
        </p>
      </form>
    </div>

    <modal-verify
      v-if="showModalValidated"
      @close="showModalValidated = false"
    ></modal-verify>
  </OnboardingLayout>
</template>

<script>
/* eslint-disable */
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import OnboardingService from "@/services/onboarding.js";
import { mapGetters } from "vuex"; // @todo: pass as param

export default {
  computed: {
    ...mapGetters(["getUserAmount", "getCustomerProductOptions"]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    },
  },
  components: {
    OnboardingLayout,
  },
  data() {
    return {
      showLoading: false,
      canContinue: false,
      showModalValidated: false,
      firstPaymentAmt: 0,
      nextPageName: "AwaitingContract",
      activeProduct: {},
      summary: {},
      paymentModal: null,
      product: {},
      onboardingData: {},
      user: {},
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    triggerPayment() {
      document.getElementById(`paymentbtn`).click();
    },
    callback: function (response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      this.close();
      // @todo: validate request... this is wrong
      if (trRef.data.status === "successful") {
        this.showSuccessMsg = { message: "Transaction Successful" };
        // console.log('yeeeeeeeeeeeeeeeeeeeeeeeee')
        // this.gotoSection(1)
      } else {
        this.showErrorMsg({ message: "Transaction fails" });
      }
    },
    async verifyPayment(callbackRes) {
      const data = {
        txref: callbackRes.transaction_id,
      };

      const onboardingStateId = localStorage.getItem("onboardingStateId");
      const HTTP = this.$httpUtils.FASTHTTP;

      try {
        this.showLoading = true;
        let res = await HTTP.post(
          `/payment/verify-payment?onboardingStateId=${onboardingStateId}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        );
        this.showLoading = false;

        this.paymentModal.close();

        await OnboardingService.updateDbData({
          currentPageName: this.nextPageName,
          onboardingStateId: onboardingStateId,
        });
        if (res.status == 200) {
          this.navTo(this.nextPageName);
          return;
        }

        if (res.data == null || res.status == 204) {
          this.showModalValidated = true;
        }
      } catch (error) {
        this.paymentModal.close();
        this.showLoading = false;
        this.showModalValidated = true;

        console.log({ error: error.response.data.detail });
        this.showErrorMsg({
          message: error.response.data.detail,
        });
      } finally {
      }
    },
    handleContinue() {
      //   if (amount === "10") this.processCard = true;
      // localStorage.redirect = true;
      // const finalAmount =
      //   process.env.NODE_ENV == "development" ? 2500 : +this.summary.amount;
      const finalAmount = this.summary.pub_key.includes("TEST")
        ? 300
        : +this.summary.amount;
      // const finalAmount = 200;

      // console.log({ finalAmount, env: process.env });
      this.paymentModal = FlutterwaveCheckout({
        public_key: this.summary.pub_key,
        tx_ref: this.genRandomNumber,
        amount: finalAmount,
        // amount: amount === "10" ? amount : this.firstPaymentAmt ? "10" : "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        //redirect_url: "/onboarding/lo?goto=lo_finish",
        meta: {
          //   consumer_id: 23,
          //   consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.user.email,
          phone_number: this.user.phoneNumber,
          name: this.user.firstName + " " + this.user.lastName,
        },
        // callback: function(data) {
        //   this.verifyPayment(data);
        //   console.log(">>>>>>>>>>>>>>>>>> callback", data);
        // },
        callback: (data) => this.verifyPayment(data),
        onclose: function (incomplete) {
          // if (incomplete || window.verified === false) {
          //   document.querySelector("#payment-failed").style.display = "block";
          // } else {
          //   document.querySelector("form").style.display = "none";
          //   if (window.verified == true) {
          //     document.querySelector("#payment-success").style.display =
          //       "block";
          //   } else {
          //     document.querySelector("#payment-pending").style.display =
          //       "block";
          //   }
          // }
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2021/09/arnergy-logo.png",
        },
      });
    },
    async getFirstPaymentAmt() {
      const state = this.$store.state.onboardingCustomerState;
      const stateId = await this.getCurrentState();

      try {
        this.showLoading = true;
        const HTTP = this.$httpUtils.FASTHTTP;

        const res = await HTTP.post(
          "/payment/summary",
          {
            onboardStateId: stateId,
            arnergyProductId: state.selectedProduct.id || state.product_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        );

        const data = res.data.data;
        if (data.status == 302) {
          // user already paid, redirect
          this.navTo(this.nextPageName);
        }
        console.log({ data, res });
        this.showLoading = false;
        // this.onboardingData = resOnboarding.data;
        // this.product = resProduct.data;
        const amount = data.amount;
        if (amount < 0) return;
        this.summary = data;
        // this.firstPaymentAmt = amount;
        this.canContinue = true;
      } catch (error) {
        console.log({ error });
        this.showLoading = false;
      }
    },
    async getCurrentState() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const url = "/onboardingstate/state";
      try {
        const response = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });
        return response.data.id;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async mounted() {
    this.user = this.$store.state.loggedInUser;
    this.getFirstPaymentAmt();
    this.getCurrentState();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

h3 {
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  margin: 20px 0px;
}

h4 {
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 13px 0px;
}

.amount {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #000000;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  display: flex;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-top: 35px;
  margin-right: 35px;
  cursor: pointer;
}

.summary {
  width: 664px;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 70%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.first {
  background: #f4f4f4;
  padding: 12px 20px;
  margin-bottom: 2px;
}

.card-section {
  display: flex;
  flex-direction: column;
  width: 800px;
}

.debit-cards {
  width: 425px;
  padding: 36px 55px;
  background: #0892d0;
  border: 1px solid #0892d0;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 13px 0px;
  cursor: pointer;

  p {
    color: #ffffff;
  }

  h2 {
    color: #ffffff;
    margin: 5px 0px;
    font-size: 24px;
    font-weight: 700;
  }
}

.debit-cards-inactive {
  width: 425px;
  padding: 36px 55px;
  border: 1px solid #efefef;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 13px 0px;
  cursor: pointer;

  p {
    color: #000000;
  }

  h2 {
    color: #000000;
    margin: 5px 0px;
    font-size: 24px;
    font-weight: 700;
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;
  margin-top: -20rem;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
.kyc-row {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/pay-deposit/index.vue